<template lang="pug">
  div
    doc-markdown(source=`
    ## Profiling Select \`profiling-select\`
    Intermediary wrapper between our profiling Sections and the \`sw-select\` generic component. Handles styling & error management.
    `)

    doc-preview(vue=`
    .mb-3 Which CSS Framework do we use ?
    div(class="w-1/4")
      profiling-select(
        v-model="chosenOption"
        :options="availableOptions"
        :error="error"
        :dropdown-open="!chosenOption"
        filterable
        placeholder="Make your choice"
        @focus="displayError = false"
        @blur="displayError = true"
      )

    <script>
      ...
      data () {
        return {
          chosenOption: '',
          availableOptions: [{ value: 'boostrap', label: 'Bootstrap'}, { value: 'bulma', label: 'Bulma' }, { value: 'tailwind', label: 'Tailwind CSS'}],
          displayError: false,
        };
      },
      computed: {
        error () { return this.displayError && this.chosenOption != 'tailwind'; },
      },
    </script>
    `)
      .mb-3 Which CSS Framework do we use ?
      div(class="w-1/4")
        profiling-select(
          v-model="chosenOption"
          :options="availableOptions"
          :error="error"
          :dropdown-open="!chosenOption"
          filterable
          placeholder="Make your choice"
          @focus="displayError = false"
          @input="displayError = true"
        )
    doc-markdown(source=`
    ### Properties
  | Props               | Description                                                   | Type                    | Default |
  |---------------------|---------------------------------------------------------------|-------------------------|---------|
  | \`value\` (v-model) | Value of the option chosen by the user.	                      | String, Number          | -       |
  | \`error\`           | Whether the red error highlighting should be displayed or not.| Boolean                 | false   |
  | \`disabled\`        | Whether the component is disabled.                            | Boolean                 | false   |
  | \`filterable\`              | Whether a query field is displayed to allow typing a search query in the dropdown<br \>(not displayed on mobile). | Boolean| false |

    All props are transfered automatically to the generic child component. So for instance, passing props like \`options\`, \`placeholder\` or \`dropdown-open\` will be passed along to the inner \`sw-select\`. See the documentation of \`sw-select\` for more details about of the inner generic component works.
    `)

    doc-markdown(source=`
    ### Events
  | Event name | Description                                                   | Parameters             | Usage      |
  |------------|---------------------------------------------------------------|:----------------------:|------------|
  | input      | Triggered when an option is selected.                         | selected option        | \`@input\` |
  | focus      | Triggered when the visible part of the component is focused.  | Array of checked items | \`@focus\` |
  | blur       | Triggered when the visible part of the component is blurred.  | Array of checked items | \`@blur\`  |
    `)
</template>

<script>
  export default {
    data () {
      return {
        chosenOption: '',
        availableOptions: [{ value: 'boostrap', label: 'Bootstrap'}, { value: 'bulma', label: 'Bulma' }, { value: 'tailwind', label: 'Tailwind CSS'}],
        displayError: false,
      };
    },
    computed: {
      error () { return this.displayError && this.chosenOption != 'tailwind'; },
    },
  };
</script>
